import { store } from "@/services/store";
import { Link } from "react-router-dom";
import { socialLinks } from "@/data/social";
import "./footer.css";

const institutionalLinks = [
  { label: "Sobre nós", to: "/" },
  { label: "Trocas e Devoluções", to: "/politica-de-trocas" },
  { label: "Meus pedidos", to: "/meus-pedidos" },
  { label: "Fale conosco", to: "/contato" },
  { label: "Seja um afiliado", to: "/afiliados" },
];

const supportLinks = [
  { icon: "ri-whatsapp-line", label: "WhatsApp", href: store.whatsapp, external: true },
  { icon: "ri-mail-line", label: "E-mail", href: `mailto:${store.email}`, external: false },
  { icon: "ri-question-line", label: "Central de Ajuda", href: "/contato", external: false },
];

// Bandeiras aceitas (logotipos oficiais, em public/payment). Cada uma fica num selo branco
// para aparecer bem sobre o rodapé escuro.
const paymentBrands = [
  { label: "Visa", file: "visa.svg" },
  { label: "Mastercard", file: "mastercard.svg" },
  { label: "American Express", file: "amex.svg" },
  { label: "Elo", file: "elo.svg" },
  { label: "Pix", file: "pix.svg" },
  { label: "Boleto", file: "boleto.png", full: true },
];

// Selos de segurança do rodapé (imagens em public/security). São ilustrativos: mostre só o que for verdadeiro para a loja.
const securitySeals = [
  { label: "Google Safe Browsing", file: "google-safe-browsing.webp" },
  { label: "Site protegido, certificado SSL", file: "site-protegido-ssl.webp" },
  { label: "Secured by Sectigo", file: "sectigo.webp" },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="sf-main">
        <div className="sf-brand">
          <Link to="/" className="sf-logo" aria-label="Rica Tanto — página inicial">
            <img src={`${import.meta.env.BASE_URL}rica-tanto-logo.webp`} alt="Rica Tanto" />
          </Link>
          <p>Acessórios que valorizam sua história. Estilo, qualidade e bom gosto sempre com você.</p>
          {socialLinks.length > 0 && (
            <div className="sf-social">
              <span>Siga a gente</span>
              <ul>
                {socialLinks.map((social) => (
                  <li key={social.label}>
                    <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                      <i className={social.icon} aria-hidden="true"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <nav className="sf-col" aria-label="Institucional">
          <h4>Institucional</h4>
          <ul>
            {institutionalLinks.map((link) => (
              <li key={link.label}><Link to={link.to}>{link.label}</Link></li>
            ))}
          </ul>
        </nav>

        <nav className="sf-col" aria-label="Atendimento">
          <h4>Atendimento</h4>
          <ul>
            {supportLinks.map((link) => (
              <li key={link.label}>
                {link.external || link.href.startsWith("mailto:")
                  ? <a href={link.href} {...(link.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}><i className={link.icon} aria-hidden="true" />{link.label}</a>
                  : <Link to={link.href}><i className={link.icon} aria-hidden="true" />{link.label}</Link>}
              </li>
            ))}
          </ul>
        </nav>

        <div className="sf-col">
          <h4>Formas de pagamento</h4>
          <div className="sf-pay">
            {paymentBrands.map(({ label, file, full }) => (
              <span key={label} className={`sf-pay-badge${full ? " is-full" : ""}`} title={label}>
                <img src={`${import.meta.env.BASE_URL}payment/${file}`} alt={label} loading="lazy" decoding="async" />
              </span>
            ))}
          </div>
          <h4 className="sf-security-title">Segurança</h4>
          <p className="sf-security">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            <span>Compra 100% segura<br />Seus dados protegidos</span>
          </p>
          <div className="sf-seals">
            {securitySeals.map(({ label, file }) => (
              <span key={label} className="sf-seal">
                <img src={`${import.meta.env.BASE_URL}security/${file}`} alt={label} loading="lazy" decoding="async" />
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="sf-legal">
        <p><span className="sf-nobr">© 2026 Rica Tanto. Todos os direitos reservados.</span> <span className="sf-sep" aria-hidden="true">·</span> <span className="sf-nobr">{store.legalName} · CNPJ {store.cnpj}</span></p>
      </div>

      <div className="sf-credit">
        <a href="https://www.serraconsultora.com" target="_blank" rel="noopener noreferrer">
          Orgulhosamente desenvolvido por <strong>Serra Consultoria e Tecnologia</strong>
        </a>
      </div>
    </footer>
  );
}
